<style>
.iam {
    background: linear-gradient(
        to right,
        #90e0ef 0%,
        #5e60ce 50%,
        #7209b7 100%
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
}
</style>
<div class="iam bg0">I am a guy(Oh yeah for those who are wondering, no blog post will gonner come soon) </div>
